var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _line2, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _text, _text2, _text3, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _line3, _line4, _path2, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _text4, _text5, _text6, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _line5, _line6, _path3, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _text7, _text8, _text9, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _line7, _line8, _path4, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _text10, _text11, _text12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChartCorrelation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 420 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "co-bg",
    cx: "50%",
    cy: "40%",
    r: "60%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6F8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDF0EF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "co-grid",
    x: 0,
    y: 0,
    width: 12,
    height: 12,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 0.55,
    fill: "#C7D1CC",
    opacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 200,
    rx: 14,
    fill: "url(#co-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 94,
    height: 184,
    rx: 7,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 70,
    height: 136,
    fill: "url(#co-grid)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 14,
    height: 136,
    fill: "#f472b6",
    fillOpacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 20,
    width: 14,
    height: 136,
    fill: "#c084fc",
    fillOpacity: 0.12
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 20,
    width: 14,
    height: 136,
    fill: "#818cf8",
    fillOpacity: 0.12
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 20,
    width: 14,
    height: 136,
    fill: "#60a5fa",
    fillOpacity: 0.12
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 20,
    width: 14,
    height: 136,
    fill: "#34d399",
    fillOpacity: 0.12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 156,
    x2: 94,
    y2: 156,
    stroke: "#A7B7AF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 20,
    x2: 24,
    y2: 156,
    stroke: "#A7B7AF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,40 C30,45 36,65 46,90 C56,112 68,130 94,140",
    stroke: "#32d1c8",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "30,55  33,60  30,65  27,60",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "36,78  39,83  36,88  33,83",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "44,96  47,101 44,106 41,101",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "54,110 57,115 54,120 51,115",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "64,118 67,123 64,128 61,123",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "74,126 77,131 74,136 71,131",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "84,132 87,137 84,142 81,137",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 59,
    y: 170,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "FZI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 88,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,15,88)"
  }, "Best A")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 59,
    y: 180,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    fontWeight: 500
  }, "Best A")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 8,
    width: 94,
    height: 184,
    rx: 7,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 20,
    width: 70,
    height: 136,
    fill: "url(#co-grid)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 20,
    width: 14,
    height: 136,
    fill: "#f472b6",
    fillOpacity: 0.12
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 20,
    width: 14,
    height: 136,
    fill: "#c084fc",
    fillOpacity: 0.12
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 20,
    width: 14,
    height: 136,
    fill: "#818cf8",
    fillOpacity: 0.12
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 20,
    width: 14,
    height: 136,
    fill: "#60a5fa",
    fillOpacity: 0.12
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 20,
    width: 14,
    height: 136,
    fill: "#34d399",
    fillOpacity: 0.12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 156,
    x2: 198,
    y2: 156,
    stroke: "#A7B7AF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 20,
    x2: 128,
    y2: 156,
    stroke: "#A7B7AF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128,25 C132,32 138,55 148,90 C158,118 170,138 198,148",
    stroke: "#32d1c8",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    fill: "none"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "134,38  137,43  134,48  131,43",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "140,62  143,67  140,72  137,67",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "150,95  153,100 150,105 147,100",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "160,118 163,123 160,128 157,123",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "170,132 173,137 170,142 167,137",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "180,140 183,145 180,150 177,145",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 163,
    y: 170,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "FZI")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 88,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,119,88)"
  }, "Best B")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 163,
    y: 180,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    fontWeight: 500
  }, "Best B")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 8,
    width: 94,
    height: 184,
    rx: 7,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 20,
    width: 70,
    height: 136,
    fill: "url(#co-grid)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 20,
    width: 14,
    height: 136,
    fill: "#f472b6",
    fillOpacity: 0.12
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 20,
    width: 14,
    height: 136,
    fill: "#c084fc",
    fillOpacity: 0.12
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 20,
    width: 14,
    height: 136,
    fill: "#818cf8",
    fillOpacity: 0.12
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 20,
    width: 14,
    height: 136,
    fill: "#60a5fa",
    fillOpacity: 0.12
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 20,
    width: 14,
    height: 136,
    fill: "#34d399",
    fillOpacity: 0.12
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 156,
    x2: 302,
    y2: 156,
    stroke: "#A7B7AF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 20,
    x2: 232,
    y2: 156,
    stroke: "#A7B7AF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232,35 C238,42 244,62 254,88 C264,114 276,134 302,146",
    stroke: "#32d1c8",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    fill: "none"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "238,48  241,53  238,58  235,53",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "246,70  249,75  246,80  243,75",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "256,96  259,101 256,106 253,101",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "266,116 269,121 266,126 263,121",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "278,132 281,137 278,142 275,137",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "290,142 293,147 290,152 287,147",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 267,
    y: 170,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "FZI")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 223,
    y: 88,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,223,88)"
  }, "Lambda")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 267,
    y: 180,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    fontWeight: 500
  }, "Lambda")), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 8,
    width: 92,
    height: 184,
    rx: 7,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 20,
    width: 68,
    height: 136,
    fill: "url(co-grid)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 20,
    width: 14,
    height: 136,
    fill: "#f472b6",
    fillOpacity: 0.12
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 20,
    width: 14,
    height: 136,
    fill: "#c084fc",
    fillOpacity: 0.12
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 20,
    width: 14,
    height: 136,
    fill: "#818cf8",
    fillOpacity: 0.12
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 20,
    width: 14,
    height: 136,
    fill: "#60a5fa",
    fillOpacity: 0.12
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 20,
    width: 12,
    height: 136,
    fill: "#34d399",
    fillOpacity: 0.12
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 336,
    y1: 156,
    x2: 404,
    y2: 156,
    stroke: "#A7B7AF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 336,
    y1: 20,
    x2: 336,
    y2: 156,
    stroke: "#A7B7AF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336,55 C342,58 350,75 360,100 C370,122 382,138 404,146",
    stroke: "#32d1c8",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    fill: "none"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "340,65  343,70  340,75  337,70",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "348,80  351,85  348,90  345,85",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "358,104 361,109 358,114 355,109",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "368,122 371,127 368,132 365,127",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "380,136 383,141 380,146 377,141",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "396,143 399,148 396,153 393,148",
    fill: "#fb923c",
    fillOpacity: 0.85
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 170,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "FZI")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 327,
    y: 88,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,327,88)"
  }, "Swir")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 180,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    fontWeight: 500
  }, "Swir")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChartCorrelation);
export default __webpack_public_path__ + "static/media/empty-chart-correlation.ca01373fcec0ef2c4c043bd55bc43efe.svg";
export { ForwardRef as ReactComponent };